import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI, apiHelpers } from '../api/api';
import '../css/Login.css';

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await authAPI.requestPasswordReset(email);
      toast.success(result.message || 'Jelszó visszaállítási link elküldve!');
      setTimeout(() => {
        if (onBackToLogin) {
          onBackToLogin();
        } else {
          navigate('/auth');
        }
      }, 2000);
    } catch (error) {
      toast.error(apiHelpers.handleApiError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div style={{ textAlign: 'center', width: '100%', marginBottom: '15px' }}>
        <h2 style={{ fontSize: '2rem', margin: '0', lineHeight: '1.2' }}>Jelszó</h2>
        <h2 style={{ fontSize: '2rem', margin: '0', lineHeight: '1.2' }}>visszaállítás</h2>
      </div>
      <p style={{ fontSize: '14px', color: '#222', margin: '0 0 20px 0', textAlign: 'center', width: '100%' }}>
        Add meg az email címed és küldünk egy linket a jelszavad visszaállításához.
      </p>
      <label htmlFor="email">Email</label>
      <input
        type="email"
        placeholder="Email cím..."
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        disabled={isLoading}
      />
      <button type="submit" disabled={isLoading}>
        {isLoading ? 'Küldés...' : 'Visszaállítási link küldése'}
      </button>
      <div style={{ marginTop: '15px', width: '100%', textAlign: 'center' }}>
        <span onClick={() => onBackToLogin ? onBackToLogin() : navigate('/auth')} style={{ color: '#333', fontSize: '0.97rem', cursor: 'pointer', textDecoration: 'underline' }}>
          Vissza a bejelentkezéshez
        </span>
      </div>
    </form>
  );
};

export default ForgotPassword;
